import React from 'react';
import { ObjectFieldTemplateProps } from '@rjsf/utils';
import { Header } from '../../components';
import Spacer from 'src/components/Layout/Spacer';

/**
 * Defines how the Objects will be rendered in ReactJsonSchema.
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#objectfieldtemplate
 * @param props ObjectFieldTemplateProps
 * @returns Layout for the Object representation in React Json Schema.
 */
export const ObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  return (
    <div>
      <Header title={props.title} />

      {props.properties.map((element, index) => (
        <span key={index}>
          {element.content}
          <Spacer height="1rem" />
        </span>
      ))}
    </div>
  );
};
